import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Table } from 'primeng/table';
import { ChaseTransactionLogsService } from './Service/chase-transaction-logs-service';

@Component({
    selector: 'app-chase-transaction-logs',
    templateUrl: './chase-transaction-logs.component.html',
    styleUrls: ['./chase-transaction-logs.component.css'],
    providers: [ChaseTransactionLogsService],
    standalone: false
})
export class ChaseTransactionLogsComponent implements OnInit {

  @ViewChild('dtTrans') dtTrans!: Table;   // reference to <p-table>

  getChaseTransactionDetails: any[] = [];
  loadingChaseTransactionLogs: boolean = false;

  constructor(
    private chaseTransactionLogsService: ChaseTransactionLogsService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.loadChaseTransactionLogs();
  }

  // ✅ Load data from service
  loadChaseTransactionLogs(): void {
    this.loadingChaseTransactionLogs = true;
    this.chaseTransactionLogsService.GetChaseTransactionLogs().subscribe({
      next: (data) => {
        this.getChaseTransactionDetails = data;
        this.loadingChaseTransactionLogs = false;
      },
      error: (err) => {
        console.error('Error loading transaction logs', err);
        this.loadingChaseTransactionLogs = false;
      }
    });
  }

  // ✅ Reset all filters/search in table
  clearFilters(): void {
    if (this.dtTrans) {
      this.dtTrans.clear();
    }
  }

  // ✅ Action handlers (match the buttons in your HTML)
  onViewDetails(row: any): void {
    console.log('View details:', row);
    // e.g. open a PrimeNG dialog here
  }

  onDeleteTransaction(row: any): void {
    console.log('Delete transaction:', row);
    // call delete API here if needed
  }
}

// What Changed in this file

// Added @ViewChild('dtTrans') dtTrans!: Table; → lets you control the table (clear filters, etc.).

// Renamed GetChaseTransactionLogsGrid → loadChaseTransactionLogs (Angular style, lowercase first letter).

// Used subscribe({ next, error }) for better error handling.

// Added helper methods clearFilters(), onViewDetails(), and onDeleteTransaction() to match your new HTML buttons.

// Cleaned constructor injection (renamed ChaseTransactionLogsService → chaseTransactionLogsService as per Angular style guide).